define("shared/components/shared/publish/index", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @isPosted}}
    {{! Already Posted }}
    <div class={{concat-classes "cPM--field" (if this.canUsePostActivityLog "u--m__l__auto")}}>
      <div class="cPM--field__icon">
        {{svg-jar this.timePickerIcon.assetName class=this.timePickerIcon.className}}
      </div>
      <div class="cPM--field__content is--noExpand">
        <span class="u--m__tb__sm">
          {{t "post.header.published_at" postedTime=this.postedTime}}
        </span>
      </div>
    </div>
  {{else}}
    <div class={{concat-classes "cPM--field" (if this.canUsePostActivityLog "u--m__l__auto")}}>
      <div class="cPM--field__icon">
        {{#if @post.isNonPublishedPost}}
          {{svg-jar "warning" class="o--icon o--icon--warning u--m__r__xs"}}
        {{else}}
          {{svg-jar this.timePickerIcon.assetName class=this.timePickerIcon.className}}
        {{/if}}
      </div>
      <div class="cPM--field__content is--noExpand">
        <div class="o--btnBar cPM--publishConfig">
          <Shared::Publish::Switcher
            @isCarouselPost={{@isCarouselPost}}
            @isDisabledPost={{@isDisabledPost}}
            @post={{@post}}
            @removeCustomCover={{@removeCustomCover}}
            @showInstagramAuthStatus={{@showInstagramAuthStatus}}
            @socialProfile={{@socialProfile}}
          />
          <span class="o--btnBar__text">
            {{this.buttonBarTranslation}}
          </span>
          <Shared::DateTimePicker
            @altFormat="Y/m/d h:i K"
            @dateTime={{@post.scheduledTime}}
            @disabled={{this.isDisabled}}
            @enableTime={{true}}
            @inputClass="cPM--field__dropdownInput qa--date_picker_dropdown"
            @minuteIncrement="15"
            @onDateChange={{@updateScheduledTime}}
            @onDateChangeOptions={{@post}}
            @pickerClass="o--btn cPM--field__dropdown u--m__l__0"
            @pickerContainerId={{this.pickerContainerId}}
            @pickerId={{this.pickerContainerId}}
            @placeholder={{t "shared_phrases.schedule_post"}}
            @setFlatpickrReference={{@setFlatpickrReference}}
            @showCaretIcon={{true}}
          />
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "p1gEYPaU",
    "block": "[[[41,[30,1],[[[1,\"  \"],[10,0],[15,0,[28,[37,1],[\"cPM--field\",[52,[30,0,[\"canUsePostActivityLog\"]],\"u--m__l__auto\"]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"cPM--field__icon\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[[30,0,[\"timePickerIcon\",\"assetName\"]]],[[\"class\"],[[30,0,[\"timePickerIcon\",\"className\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cPM--field__content is--noExpand\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__tb__sm\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"post.header.published_at\"],[[\"postedTime\"],[[30,0,[\"postedTime\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[15,0,[28,[37,1],[\"cPM--field\",[52,[30,0,[\"canUsePostActivityLog\"]],\"u--m__l__auto\"]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"cPM--field__icon\"],[12],[1,\"\\n\"],[41,[30,2,[\"isNonPublishedPost\"]],[[[1,\"        \"],[1,[28,[35,2],[\"warning\"],[[\"class\"],[\"o--icon o--icon--warning u--m__r__xs\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[[30,0,[\"timePickerIcon\",\"assetName\"]]],[[\"class\"],[[30,0,[\"timePickerIcon\",\"className\"]]]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cPM--field__content is--noExpand\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar cPM--publishConfig\"],[12],[1,\"\\n        \"],[8,[39,4],null,[[\"@isCarouselPost\",\"@isDisabledPost\",\"@post\",\"@removeCustomCover\",\"@showInstagramAuthStatus\",\"@socialProfile\"],[[30,3],[30,4],[30,2],[30,5],[30,6],[30,7]]],null],[1,\"\\n        \"],[10,1],[14,0,\"o--btnBar__text\"],[12],[1,\"\\n          \"],[1,[30,0,[\"buttonBarTranslation\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,5],null,[[\"@altFormat\",\"@dateTime\",\"@disabled\",\"@enableTime\",\"@inputClass\",\"@minuteIncrement\",\"@onDateChange\",\"@onDateChangeOptions\",\"@pickerClass\",\"@pickerContainerId\",\"@pickerId\",\"@placeholder\",\"@setFlatpickrReference\",\"@showCaretIcon\"],[\"Y/m/d h:i K\",[30,2,[\"scheduledTime\"]],[30,0,[\"isDisabled\"]],true,\"cPM--field__dropdownInput qa--date_picker_dropdown\",\"15\",[30,8],[30,2],\"o--btn cPM--field__dropdown u--m__l__0\",[30,0,[\"pickerContainerId\"]],[30,0,[\"pickerContainerId\"]],[28,[37,3],[\"shared_phrases.schedule_post\"],null],[30,9],true]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@isPosted\",\"@post\",\"@isCarouselPost\",\"@isDisabledPost\",\"@removeCustomCover\",\"@showInstagramAuthStatus\",\"@socialProfile\",\"@updateScheduledTime\",\"@setFlatpickrReference\"],false,[\"if\",\"concat-classes\",\"svg-jar\",\"t\",\"shared/publish/switcher\",\"shared/date-time-picker\"]]",
    "moduleName": "shared/components/shared/publish/index.hbs",
    "isStrictMode": false
  });
  const TIME_PICKER_ICONS = {
    error: {
      assetName: 'danger',
      className: 'o--icon o--icon--danger'
    },
    warning: {
      assetName: 'warning',
      className: 'o--icon o--icon--warning'
    },
    success: {
      assetName: 'verified',
      className: 'o--icon o--icon--success'
    },
    schedule: {
      assetName: 'schedule',
      className: 'o--icon'
    },
    notification: {
      assetName: 'notification',
      className: 'o--icon'
    },
    auto: {
      assetName: 'instant',
      className: 'o--icon'
    }
  };
  let IndexComponent = _exports.default = (_class = class IndexComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "userConfig", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
    }
    get canUsePostActivityLog() {
      return this.auth.currentAccount.canUsePostActivityLog;
    }
    get profileName() {
      return this.intl.t(`shared_words.${this.args.socialProfile.profileType}`);
    }
    get isDisabled() {
      return this.args.post.isSaving || !this.args.post.isEditable || this.args.post.isDisabledDraft || this.args.isDisabledPost;
    }
    get postedTime() {
      const postedTime = moment.unix(this.args.post.postedTime).tz(this.userConfig.currentTimeZone.identifier).format('YYYY/MM/DD hh:mm a');
      return postedTime;
    }
    get showPublishMethodSwitcher() {
      return this.args.post.isInstagram || this.args.post.isTiktok;
    }
    get timePickerIcon() {
      if (this.args.post.isPosted) {
        return this.args.post.unverified ? TIME_PICKER_ICONS.warning : TIME_PICKER_ICONS.success;
      } else if (this.args.post.platformError || this.args.post.isVideoRejected) {
        return TIME_PICKER_ICONS.error;
      }
      return this.args.post.isNotificationPost ? TIME_PICKER_ICONS.notification : TIME_PICKER_ICONS.auto;
    }
    get buttonBarTranslation() {
      if (this.showPublishMethodSwitcher) {
        return this.intl.t('post.header.on');
      }
      return `${this.intl.t('post.header.auto_publish_on')}`;
    }
    get pickerContainerId() {
      return `post-flatpickr-container_${this.args.socialProfile.id}`;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, IndexComponent);
});